<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <NotificationContainer />
  </v-app>
</template>

<script setup>
import NotificationContainer from "@/components/NotificationContainer.vue";
</script>
